import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useAuth0, ErrorBoundary, USER_GROUPS, Iframe, useGetCompany } from '@livingsecurity/shared';

import { AuthorizedLayout } from 'components';

const getApiUrl = (url) => {
  const isMonorepo = /unify-(dev|eu|prod)/.test(url);
  return `${url}/${isMonorepo ? 'unify/settings/api' : 'settings/api'}`;
};

const ApiAuthentication = ({ history }) => {
  const { isUserHasRights } = useAuth0();
  const { data: companyInfo, isLoading } = useGetCompany();
  const { unifyUrl } = useFlags();

  useEffect(() => {
    if (window.location?.href?.includes('livingsecurity.com')) {
      window.document.domain = 'livingsecurity.com';
    }
  }, []);

  useEffect(() => {
    if (
      !isLoading &&
      companyInfo &&
      !isUserHasRights([
        USER_GROUPS.LS_ADMIN,
        USER_GROUPS.UNIFY_LS_ADMIN,
        USER_GROUPS.ENTERPRISE_ADMIN,
        USER_GROUPS.UNIFY_CUSTOMER_ADMIN,
        USER_GROUPS.CUSTOMER_ADMIN,
      ])
    ) {
      history.replace('/');
    }
  }, [isLoading, companyInfo, isUserHasRights, history]);

  if (isLoading || !companyInfo || !unifyUrl) return null;

  const { region } = companyInfo;
  const url = region === 'EU' ? 'https://unify.eu.livingsecurity.com' : unifyUrl;
  const apiUrl = getApiUrl(url, region);

  return (
    <AuthorizedLayout app="API_AUTHENTICATION" hideSidebar withBottomPaddingForHubspot>
      <ErrorBoundary scope="api-authentication">
        <Iframe
          id="platform-api-authentication-frame"
          allow="clipboard-read; clipboard-write *;"
          className="embedded-iframe"
          data-testid="platform-api-authentication"
          title="Living Security API Authentication"
          src={apiUrl}
        />
      </ErrorBoundary>
    </AuthorizedLayout>
  );
};

ApiAuthentication.propTypes = {
  history: PropTypes.any.isRequired,
};

export default ApiAuthentication;
